import proxy from "api/proxy";

import ModelSaleLine from "./ModelSaleLine";
import { layoutParty } from "src/apps/Partyv2/Party.jsx";
import WizardAddPayment from "../components/WizardAddPayment";
import ProductDiscount from "apps/Activity/components/ProductDiscount";
import { ModalWizzardEvents } from "apps/Activity/components/ModalWizardEvents";
import { generateInvoiceHTML } from "apps/AppointmentScheduling_OLD/services/invoice";
import { getStorage } from "store/local";
import funcs from "tools/functions";
import tools from "tools/dates";
import { PrintIcon, PlusCircleIcon } from "components/Icons";
import useMainStore from "store/mainStore";
import { generateInvoice } from "../services/sale";

const stateColors = {
  draft: "gray",
  cancelled: "rose",
  quotation: "amber",
  processing: "indigo",
  transferred: "sky",
  done: "lime",
};

const onPrintBrowser = async (record) => {
  const model = "sale.sale";
  const session = await getStorage("ctxSession");
  const imageLogo = funcs.base64ToBlobUrl(session.company_logo, "png");

  const terminal = funcs.getCookie();
  const args = { user_id: session.user, device_id: Number(terminal.device_id) };

  const { data: ctxPrinting } = await proxy.methodCall({
    model: model,
    method: "get_printing_context",
    args: [args],
  });

  const argSale = {
    type_doc: "invoice",
    sale_id: record.id,
  };

  const { data: sale } = await proxy.methodCall({
    model: model,
    method: "get_data",
    args: [argSale],
  });

  const _sale = { ...record, ...sale };
  _sale.order = sale?.order;
  _sale.payment_term = sale?.payment_term;
  if (_sale.courtesy) {
    _sale.total_discount_amount = _sale["lines."].reduce((total, item) => {
      return total + item.base_price * item.quantity;
    }, 0);
  }

  let htmlTax;
  const infoTransferRoom = "";
  const infoTransfer = "";

  const htmlContent = await generateInvoiceHTML(
    _sale,
    ctxPrinting,
    sale,
    record,
    htmlTax,
    infoTransferRoom,
    infoTransfer,
    imageLogo,
  );
  const renderDocument = await getRenderDocument(htmlContent);
  await new Promise((resolve) => setTimeout(resolve, 600));
  renderDocument.print();
};

async function getRenderDocument(htmlContent) {
  const generatePrint = window.open("", "", "width=500,height=600");
  generatePrint.document.open();
  generatePrint.document.write(htmlContent);
  generatePrint.document.close();
  return generatePrint;
}

const onChangeLines = (activeRecord) => {
  if (activeRecord.lines) {
    const totalAmount = Array.from(activeRecord.lines.values()).reduce(
      (total, item) => {
        const sale_price =
          item.unit_price_w_tax ?? item.product.sale_price_w_tax;
        return total + item.quantity * sale_price;
      },
      0,
    );
    activeRecord.total_amount = totalAmount.toFixed(0);
  }
  return activeRecord;
};

const onChangeReservation = (activeRecord) => {
  if (!activeRecord?.reservation) {
    activeRecord.shipment_date = "";
  }
  return activeRecord;
};

const visiblePrint = (_, record) => {
  let res = false;
  if (
    (record.state === "draft" &&
      record.invoice_type === "M" &&
      record.number) ||
    record.state === "processing" ||
    record.state === "transferred" ||
    record.state === "done"
  ) {
    res = true;
  }
  return res;
};

const visibleTransfer = (_, record) => {
  let res = false;
  if (record.state === "draft" && record.lines && record.lines.size > 0) {
    res = true;
  }
  return res;
};

const disabledField = (record) => {
  return record.state !== "draft";
};

const disabledReservation = (_, record) => {
  let res = true;
  const session = getStorage("ctxSession");
  const sellerPermits = session.groups.some(
    (group) => group.name === "Venta en Reserva",
  );
  if (record.state !== "draft" || sellerPermits) {
    res = false;
  }
  return res;
};

const visibleDiscount = (record) => {
  return record.state === "draft";
};
const visibleResidual = (record) => {
  return record.state !== "draft";
};

const visiblePay = (_, record) => {
  console.log("recordvisiblePay", record);
  let res = false;
  if (
    record.lines &&
    record.lines.size > 0 &&
    record.party &&
    record.residual_amount !== 0 &&
    record.state !== "transferred" &&
    record.state !== "draft"
  ) {
    res = true;
  }
  return res;
};

const visibleQuote = (_, record) => {
  const res = record.state === "draft" && record.lines && record.lines.size > 0;

  return res;
};

const visibleShipmentDate = (record) => {
  let res = false;
  if (record?.reservation) {
    res = true;
  }
  return res;
};

const onChangeParty = async (record, storeRec) => {
  if (record.party) {
    const { data } = await proxy.search(
      "party.party",
      [["id", "=", record.party.id]],
      ["addresses"],
    );
    if (data && data[0]?.addresses?.length > 0) {
      storeRec.shipment_address = data[0].addresses[0];
      storeRec.invoice_address = data[0].addresses[0];
    } else {
      storeRec.shipment_address = null;
      storeRec.invoice_address = null;
    }
  }
};

const getFilters = () => {
  const { record } = useMainStore();
  return {
    draft: [["state", "=", "draft"]],
    all: [],
    pending: [["state", "not in", ["cancelled", "done"]]],
  };
};

function visibleProcess(_, record) {
  return record.state === "quotation" && record.residual_amount === 0;
}

function processInvoice(record) {
  generateInvoice(record.id);
}

function visibleCourtesy(_, record) {
  const session = getStorage("ctxSession");
  return (
    record?.lines?.size > 0 &&
    session.shop_?.allow_courtesy &&
    ["quotation"].includes(record.state) &&
    record?.paid_amount <= 0
  );
}

const today = tools.dateToday();

const saleView = {
  model: "sale.sale",
  activeSearch: true,
  filters: getFilters,
  domain: [
    ["shop", "=", parseInt(getStorage("ctxSession")?.shop || -1)],
    ["sale_date", ">=", `${today}`],
  ],
  form_action: ["save", "edit", "add"],
  table_action: ["add", "edit"],
  pagination: [],
  limit: 20,
  tags: {
    state: stateColors,
  },
  selectable: null,
  title: { field: "numeric", model: true },
  webfields: {
    id: { type: "integer", readOnly: true },
    name: { type: "name", readOnly: true },
    number: { type: "char", readOnly: true, searchable: true },
    "party.id_number": {
      type: "char",
      searchable: true,
    },
    "party.mobile": {
      type: "char",
      call: ["mobile", "whatsapp"],
    },
    party: {
      type: "many2one",
      model: "party.party",
      ctxView: layoutParty(),
      required: true,
      searchable: true,
      withChange: onChangeParty,
      attrs: [
        "account_receivable",
        "addresses",
        "addresses.name",
        "mobile",
        "id_number",
      ],
      readOnly: disabledField,
    },
    create_uid: {
      type: "many2one",
      model: "res.user",
      readOnly: true,
    },
    courtesy: {
      type: "boolean",
      readOnly: true,
    },
    payment_term: {
      type: "many2one",
      required: true,
      model: "account.invoice.payment_term",
    },
    invoice_address: {
      type: "many2one",
      model: "party.address",
      recSearch: () => [],
    },

    sale_date: {
      type: "date_old",
      readOnly: true,
      default: () => new Date(),
      required: true,
    },

    shipment_date: {
      type: "date_old",
      visible: visibleShipmentDate,
    },

    source: {
      type: "many2one",
      model: "sale.source",
      readOnly: true,
    },

    invoice_method: {
      type: "char",
      required: false,
    },
    state: {
      type: "char",
      readOnly: true,
      translate: true,
      default: "draft",
      tags: stateColors,
    },
    invoice_state: {
      type: "char",
      translate: true,
      readOnly: true,
      default: "draft",
    },
    residual_amount: {
      type: "numeric",
      readOnly: true,
      rounded: true,
      visible: visibleResidual,
    },
    paid_amount: {
      type: "numeric",
      readOnly: true,
      rounded: true,
      visible: visibleResidual,
    },
    shop: {
      type: "many2one",
      model: "sale.shop",
      readOnly: true,
      required: true,
    },
    reservation: {
      type: "boolean",
      withChange: onChangeReservation,
      readOnly: disabledReservation,
    },
    total_amount: {
      type: "numeric",
      readOnly: true,
      rounded: true,
    },
    comment: {
      type: "char",
      searchable: true,
      readOnly: disabledField,
    },
    description: {
      type: "char",
      searchable: true,
      readOnly: disabledField,
    },
    sale_device: {
      type: "many2one",
      model: "sale.device",
      recSearch: () => [],
      required: true,
      readOnly: true,
    },

    price_list: {
      type: "many2one",
      recSearch: () => [],
      model: "product.price_list",
      required: false,
      readOnly: true,
    },

    lines: {
      type: "one2many",
      model: "sale.line",
      ctxView: ModelSaleLine,
      withChange: onChangeLines,
    },
    agent: {
      type: "many2one",
      model: "commission.agent",
      searchable: true,
      readOnly: true,
    },
    pay: {
      type: "button",
      button_method: "",
      visible: ProductDiscount,
      color: "blue",
      onSuccessMsg: "ORDEN COMANDADA...!",
    },
    add_payment: {
      type: "button_wizard",
      Component: WizardAddPayment,
      color: "lime",
      icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
      visible: visiblePay,
      resetWizard: false,
    },
    transferred_events: {
      type: "button_wizard",
      Component: ModalWizzardEvents,
      color: "yellow",
      icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
      style: "w-10",
      visible: visibleTransfer,
      resetWizard: false,
    },
    add_discount: {
      type: "button_wizard",
      Component: ProductDiscount,
      color: "blue",
      icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
      visible: (_, record) => visibleDiscount(record),
      resetWizard: false,
    },
    pay_method: {
      type: "button",
      method: "create_sale",
      visible: visiblePay,
      style: "p-22 w-full",
    },
    add_courtesy: {
      type: "button",
      method: "set_courtesy",
      visible: visibleCourtesy,
      style: "p-22 w-full",
    },
    quote: {
      type: "button",
      button_method: "quote",
      visible: visibleQuote,
      style: "p-22 !w-full",
    },
    cancel: {
      type: "button",
      button_method: "cancel",
      visible: true,
      style: "p-22 w-full",
      color: "rose",
    },
    bill: {
      type: "button",
      method: processInvoice,
      visible: visibleProcess,
    },
    printBrowser: {
      type: "button",
      method: onPrintBrowser,
      visible: visiblePrint,
      color: "amber",
      iconRight: <PrintIcon className="h-5 w-5 fill-current" />,

      loading: false,
    },
  },
  webtree: [
    { name: "number", width: "20%" },
    { name: "party" },
    { name: "description" },
    { name: "party.id_number" },
    { name: "party.mobile", widget: "call_action" },
    { name: "create_uid" },
    { name: "sale_date" },
    { name: "shipment_date" },
    { name: "reservation" },
    { name: "courtesy" },
    { name: "paid_amount" },
    { name: "invoice_state" },
    { name: "state", widget: "badge" },
  ],
  webform: [
    { name: "party", widget: "search_add_new", edit: false },
    {
      id: "customer",
      grid: [{ name: "sale_date" }, { name: "number" }],
      size: [1, 2],
      span: "col-span-1",
    },
    {
      id: "consumer_party",
      grid: [
        { name: "payment_term" },
        { name: "agent" },
        { name: "shop" },
        { name: "sale_device" },
      ],
      size: [1, 4],
      span: "col-span-2",
    },
    { name: "description" },
    { name: "lines", component: "modal" },
    {
      id: "discounts",
      grid: [
        { name: "state", width: "7%" },
        { name: "invoice_state", width: "7%" },
        { name: "reservation" },
        { name: "shipment_date" },
        { name: "courtesy" },
      ],
      size: [1, 4],
      span: "col-span-1",
    },
    {
      id: "paid",
      grid: [
        { name: "total_amount" },
        { name: "paid_amount" },
        { name: "residual_amount" },
      ],
      size: [1, 3],
      span: "col-span-1",
    },
    {
      id: "actions",
      grid: [
        { name: "quote" },
        { name: "add_payment" },
        { name: "bill" },
        { name: "add_courtesy" },
        { name: "transferred_events" },
      ],
      size: [1, 4],
      span: "col-span-2",
    },
    {
      id: "print",
      grid: [{ name: "printBrowser" }],
      size: [1, 4],
      span: "col-span-2",
    },
  ],
};

export default saleView;
